export default {
    COPPER: 'copper',
    COPPER_ABS: 'copper-abs',
    COPPER_PVC: 'copper-pvc',
    STEEL: 'steel',
    IRON: 'iron',
    PEX: 'pex',
};
